document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".shop-concern").forEach((section) => {
    const tabs = section.querySelectorAll(".shop-concern-tab");
    const panels = section.querySelectorAll(".shop-concern-panel");

    const swipers = [];

    // Initialize Swiper for each panel
    panels.forEach((panel) => {
      const carousel = panel.querySelector(".shop-concern-carousel");

      if (!carousel) return;

      const swiper = new Swiper(carousel, {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  speed: 500,

  pagination: {
    el: carousel.querySelector(".swiper-pagination"),
    clickable: true,
  },

  breakpoints: {
    750: {
      slidesPerView: 2,
    },
    990: {
      slidesPerView: 4,
    },
  },
});

      swipers.push(swiper);
    });

    // Tab switching
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        if (tab.classList.contains("active")) return;

        const id = tab.dataset.tab;

        tabs.forEach((t) => t.classList.remove("active"));
        panels.forEach((panel) => panel.classList.remove("active"));

        tab.classList.add("active");

        const activePanel = section.querySelector(
          `.shop-concern-panel[data-panel="${id}"]`
        );

        if (activePanel) {
          activePanel.classList.add("active");

          // Update swiper after panel becomes visible
          setTimeout(() => {
            const swiperEl = activePanel.querySelector(".shop-concern-carousel");
            const swiper = swiperEl?.swiper;

            if (swiper) {
              swiper.update();
            }
          }, 50);
        }
      });
    });

    // Make sure the first visible swiper is calculated correctly
    setTimeout(() => {
      const firstSwiper = panels[0]?.querySelector(".shop-concern-carousel")
        ?.swiper;

      if (firstSwiper) {
        firstSwiper.update();
      }
    }, 100);
  });
});

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".shop-concern").forEach(function (section) {

    const toggle = section.querySelector(".shop-concern-toggle");

    if (!toggle) return;

    toggle.addEventListener("click", function () {

      const tabsContainer = section.querySelector(".shop-concern-tabs");

      const tabs = section.querySelectorAll(".shop-concern-tab");

      const expanded =
        toggle.getAttribute("aria-expanded") === "true";

      if (!expanded) {

        /* SHOW ALL */

        tabs.forEach(function (tab) {
          tab.classList.remove("shop-concern-tab-hidden");
        });

        tabsContainer.classList.add("expanded");

        toggle.setAttribute("aria-expanded", "true");
        toggle.textContent = "Show less";

      } else {

        /* SHOW ONLY FIRST 7 ON DESKTOP */

        tabs.forEach(function (tab, index) {

          if (index >= 7) {
            tab.classList.add("shop-concern-tab-hidden");
          } else {
            tab.classList.remove("shop-concern-tab-hidden");
          }

        });

        tabsContainer.classList.remove("expanded");

        toggle.setAttribute("aria-expanded", "false");
        toggle.textContent = "Show more";

      }

    });

  });

});